import { useGetProfileQuery } from "~/schemas/generated/graphql";
import { get } from "lodash";

const USER_ACCESS_OPTIONS = [
  "isEmployeeAccess",
  "isViolationAccess",
  "isZdAccess",
  "isAnnouncementsAccess",
  "isTemporaryAccessToAllDealers",
  "isAnnouncementsSend",
  "isAccountingAccess",
  "isDocumentsAccess",
  "isCameraAccess",
  "isCandidateAccess",
  "isTrustedPersonAccess",
  "ivideon_access",
  "dnm_access",
];

export const checkAccess = () => {
  const getProfile = useGetProfileQuery({});
  const user = get(getProfile, "data.UserGetter.getProfile", false);
  return [...USER_ACCESS_OPTIONS.filter((el) => !!user[el])];
};
